import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e30afc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time-adjust" }
const _hoisted_2 = { class: "hour" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, ":", -1))
const _hoisted_4 = { class: "minutes" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "minus",
      onMousedown: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeTime(-1, 5))),
      ref: "minusButton",
      onMouseup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.longPressMinus = false))
    }, " - ", 544),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.formatLeadingZero(_ctx.refactoredTime.hours)), 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.formatLeadingZero(_ctx.refactoredTime.minutes)), 1),
    _createElementVNode("div", {
      class: "plus",
      onMousedown: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeTime(1, 5))),
      ref: "plusButton",
      onMouseup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.longPressPlus = false))
    }, " + ", 544)
  ]))
}